import { useTranslation } from "react-i18next";
import React, { FC } from "react";

import { Alert, Typography } from "@components/base";
import { PageTitle } from "@components/common";

const NotAuthorized: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("Not Authorized")} />
      <Alert severity="warning" variant="outlined">
        <Typography variant="subtitle1">{t("notAuthorized.title")}</Typography>
        <Typography>{t("notAuthorized.body")}</Typography>
      </Alert>
    </>
  );
};

export default NotAuthorized;
